import React from 'react';
import { Box } from '@mui/system';
import { Card } from '@mui/material';
import { styles } from './error-helpers';
import InsufficientPermissionSvg from '../../assets/images/403-error.svg';

export const InsufficientPermissionsError = (): React.JSX.Element => {
    return (
        <Box sx={styles.mainContainer}>
            <Card sx={styles.cardContainer}>
                <img
                    src={InsufficientPermissionSvg}
                    alt='insufficient permissions'
                    style={styles.insufficientPermissionsImage}
                />
            </Card>
        </Box>
    );
};
